const t = "팝업창으로 이동하려면 Tab 키를 누르세요", r = {
  triggerHint: t
};
export {
  r as default,
  t as triggerHint
};
